import React from "react";

const CopyRigthFooter = () => {
  return (
    <div className="py-4 bg-[#0066b1]">
      <div className="text-center text-white text-sm font-semibold">
        ©AiSPRY. All rights reserved.
      </div>
    </div>
  );
};

export default CopyRigthFooter;
